import { combineReducers } from 'redux-immutable'

import menuReducer from './components/Menu/reducer'
import contentReducer from './components/Content/reducer'

const userProfileReducer = combineReducers({
    menu: menuReducer,
    content: contentReducer,
})

export default userProfileReducer
